/**
 * Global class to store options, etc.
 */
import _Nutshell from './src/Nutshell';

/**
 * Registrate ServerRequest
 * a XHR wrapper for Nutshell
 */
import _ServerRequest from './src/ServerRequest';
_Nutshell.registrateDefaults(_ServerRequest.getName(), _ServerRequest.getDefaults());

/**
 * Registrate Setup.
 * Static class to help setup a website.
 */
import _Setup from './src/Setup';
_Nutshell.registrateDefaults(_Setup.getName(), _Setup.getDefaults());

/**
 * Registrate Socket
 * A Websocket wrapper for Nutshell
 */
import _Socket from './src/Socket';
_Nutshell.registrateDefaults(_Socket.getName(), _Socket.getDefaults())

/**
 * Registrate Validator
 * A class to validate a form
 */
import _Validator from './src/Validator';
_Nutshell.registrateDefaults(_Validator.getName(), _Validator.getDefaults());

/**
 * Registrate Encryption
 * A class to encrypt data. Based on the project settings rsa of gpg is used.
 */
const _Encryption = ( ENCRYPTION.rsa ) ? require('./src/encryption/rsa-aes/Encryption').default : require('./src/encryption/gpg/Encryption').default;
_Nutshell.registrateDefaults(_Encryption.getName(), _Encryption.getDefaults());

/**
 * Helper classes.
 * No need to registrate.
 */
import _FormElements from './src/FormElements';
import _ApplicationStorage from './src/ApplicationStorage';

/**
 * Export classes
 */
export const ApplicationStorage = _ApplicationStorage;
export const FormElements = _FormElements;
export const Nutshell = _Nutshell;
export const Encryption = _Encryption;
export const ServerRequest = _ServerRequest;
export const Setup = _Setup;
export const Socket = _Socket;
export const Validator = _Validator;

export default {
    Nutshell:_Nutshell,
    ApplicationStorage: _ApplicationStorage,
    Encryption: _Encryption,
    FormElements: _FormElements,
    ServerRequest: _ServerRequest,
    Setup: _Setup,
    Socket: _Socket,
    Validator: _Validator
};
